import React from 'react';

import PlanBundle from '~/components/plans/bundles-page/plan-bundle';

import styles from '~/components/plans/bundles-page/plan-bundle-page.module.scss';

const DesktopPlans = ({
  bundles,
  onSelect = () => {},
  isFlexPay,
  planType,
  showHardmarkPricing,
  isRecommended,
  showFirstShipmentDate,
  ctaText,
}) => {
  return (
    <div
      className={styles.desktopPlansContainer}
      id="desktop-plan-card-container"
    >
      {bundles?.map((bundle, index) => (
        <div
          key={bundle?.uuid || bundle?.purchaseSku?.skuId}
          className={styles.desktopPlanContainer}
        >
          <PlanBundle
            bundle={bundle}
            isFlexPay={isFlexPay}
            lastItem={bundles?.length === index + 1}
            onSelect={() => onSelect(index)}
            planType={planType}
            showPurchaseButton
            id={`plan-${index}`}
            showHardmarkPricing={showHardmarkPricing}
            isRecommended={isRecommended}
            firstShipmentDate={
              showFirstShipmentDate && bundle?.carts?.[0]?.shipDate
            }
            ctaText={ctaText}
          />
        </div>
      ))}
    </div>
  );
};

export default DesktopPlans;
